import {HttpService} from "../http/HttpService";
import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {CreateUserLimitRequest, ListResponse, UpdateUserLimitRequest, UserLimit} from "../http/protocol";

export interface UserLimitListResponse extends ListResponse {
	items?: UserLimit[];
}

export class UserLimitService extends AbstractAdminEntityService<UserLimit, UserLimitListResponse> {

	constructor(http: HttpService) {
		super("/user", http);
	}

	listByUser(userId: number): Promise<UserLimit[]> {
		return this.http.get(`${this.entityPath}/${userId}/limits`);
	}

	create(userId: number, req: CreateUserLimitRequest): Promise<UserLimit> {
		return this.http.post(`${this.entityPath}/${userId}/limits`, req);
	}

	update(userId: number, limitId: number, req: UpdateUserLimitRequest): Promise<UserLimit> {
		return this.http.put(`${this.entityPath}/${userId}/limits/${limitId}`, req);
	}

    delete(userId: number, limitId: number): Promise<void> {
        return this.http.delete(`${this.entityPath}/${userId}/limits/${limitId}`).then(() => undefined);
    }

    addTag(userId: number, limitId: number, tagNameId: string): Promise<void> {
        return this.http.post(`${this.entityPath}/${userId}/limits/${limitId}/tags`, tagNameId).then(() => undefined);
    }

    removeTag(userId: number, limitId: number, tagNameId: string): Promise<{}> {
        return this.http.delete(`${this.entityPath}/${userId}/limits/${limitId}/tags/${encodeURIComponent(tagNameId)}`);
    }
}
